import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();

// true dopo "Esci": il login successivo riparte dall'Hub invece di tornare all'ultima pagina
let uscitaVolontaria = false;
export const eUscitaVolontaria = () => uscitaVolontaria;

export function AuthProvider({ children }) {
  const [utente, setUtente] = useState(null);
  const [caricamento, setCaricamento] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUtente(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setCaricamento(false));
    } else {
      setCaricamento(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    uscitaVolontaria = false;
    localStorage.setItem('token', res.data.token);
    setUtente(res.data.utente);
    return res.data;
  };

  const logout = () => {
    uscitaVolontaria = true;
    localStorage.removeItem('token');
    setUtente(null);
  };

  return (
    <AuthContext.Provider value={{ utente, caricamento, login, logout, setUtente }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
